import { useHistory } from "react-router-dom";

const Header = () => {
  const history = useHistory();

  /**
   * 页面迁移
   * @param {*} pageName 页面
   */
  const navagatePage = (pageName) => {
    return (e) => {
      e.preventDefault();
      history.push(pageName);
    };
  };

  return (
    <>
      {/* description */}
      <meta name="description" content={`Family Computer Games`} />
      <meta property="og:description" content={`Family Computer Games`} />
      <meta name="twitter:description" content={`Family Computer Games`} />
      {/* Open Graph / Facebook */}
      <meta content="Family Computer Games" property="og:site_name" />
      <meta content="https://fc-game.github.io" property="og:url" />
      <meta content="website" property="og:type" />
      {/* Twitter */}
      <meta content="@Seiriryu" name="twitter:site" />
      <meta content="@Seiriryu" name="twitter:creator" />
      <meta content="summary_large_image" name="twitter:card" />
      <meta content="https://fc-game.github.io" name="twitter:url" />
      <meta content="https://fc-game.github.io" name="twitter:domain" />
      <meta
        content="fc games,online game,Family Computer Games"
        name="keywords"
      />
      <meta content={`Family Computer Games`} name="twitter:title" />
      {/* JSON+Id */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "http://schema.org",
          "@type": "WebSite",
          name: "Family Computer Games",
          url: "https://fc-game.github.io",
        })}
      </script>
      {/* navbar */}
      <nav className="navbar">
        <div className="logo">
          <i className="fas fa-gamepad"></i>
          FC<span style={{ marginLeft: "10px" }}>GAME</span>
        </div>
        <ul className="nav-links">
          <li>
            <div onClick={navagatePage("/")} className="active">
              <a href="/#">Home</a>
            </div>
          </li>
          <li>
            <div onClick={navagatePage("/policy")}>
              <a href="/#">Policy</a>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
